import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const navItems = [
  { label: 'Basketball', route: '/basketball' },
  { label: 'Fitness', route: '/fitness' },
  { label: 'About', section: 'coach' },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const goTo = (item) => {
    setMenuOpen(false);
    if (item.route) {
      navigate(item.route);
      return;
    }
    if (location.pathname === '/') {
      const element = document.getElementById(item.section);
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/', { state: { scrollTo: item.section } });
    }
  };

  const goHome = () => {
    setMenuOpen(false);
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled || menuOpen ? 'bg-black/90 backdrop-blur-md border-b border-neutral-900' : 'bg-transparent'
    }`}>
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <button
            data-testid="header-logo"
            onClick={goHome}
            className="text-xl sm:text-2xl font-black tracking-tight text-left"
          >
            <span className="text-white">THE DILLON</span>
            <span className="text-gray-400"> BLUEPRINT</span>
          </button>

          <nav className="hidden lg:flex items-center gap-8">
            {navItems.map((item) => (
              <button
                key={item.label}
                data-testid={`nav-${item.label.toLowerCase()}`}
                onClick={() => goTo(item)}
                className="text-gray-300 hover:text-white transition-colors font-semibold text-sm tracking-widest uppercase"
              >
                {item.label}
              </button>
            ))}
          </nav>

          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-white"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {menuOpen && (
          <nav data-testid="mobile-menu" className="lg:hidden flex flex-col gap-4 py-6">
            {navItems.map((item) => (
              <button
                key={item.label}
                onClick={() => goTo(item)}
                className="text-gray-300 hover:text-white transition-colors font-semibold tracking-widest uppercase text-left"
              >
                {item.label}
              </button>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
